import { render, staticRenderFns } from "./RevCardSkeleton.vue?vue&type=template&id=4448a40e&scoped=true"
import script from "./RevCardSkeleton.vue?vue&type=script&lang=js"
export * from "./RevCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./RevCardSkeleton.vue?vue&type=style&index=0&id=4448a40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4448a40e",
  null
  
)

export default component.exports